import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class MemurIzinTalepAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "MemurIzinTalep";
        super(baseUrl);
    }

    perSicilBilgiKontrol(request: PerSicilBilgiKontrolRequest) {
        return this.post("PerSicilBilgiKontrol", request );
    }

    memIzinTalepDel(request: MemIzinTalepDelRequest) {
        return this.post("MemIzinTalepDel", request);
    }

    memIzinTalepGet(request: MemIzinTalepGetRequest) {
        return this.post("MemIzinTalepGet", request);
    }

    memIzinTalepList(request: MemIzinTalepListRequest) {
        return this.post("MemIzinTalepList", request);
    }

    memIzinTalepSave(request: MemIzinTalepSaveRequest) {
        return this.post("MemIzinTalepSave", request);
    }

    memIzinTalepDetayList(request: MemIzinTalepDetayListRequest) {
        return this.post("MemIzinTalepDetayList", request);
    }

    memIzinTalepDurumUpd(request: MemIzinTalepDurumUpdRequest) {
        return this.post("MemIzinTalepDurumUpd", request);
    }

    memIzinDurumList(request: MemIzinDurumListRequest) {
        return this.post("MemIzinDurumList", request);
    }

    perIzinTuruTanimiSaatList(request: PerIzinTuruTanimiSaatListRequest) {
        return this.post("PerIzinTuruTanimiSaatList", request);
    }

    perIzinTuruTnmDtySaatLst(request: PerIzinTuruTnmDtySaatLstRequest) {
        return this.post("PerIzinTuruTnmDtySaatLst", request);
    }

    memIzinSuresiBul(request: MemIzinSuresiBulRequest) {
        return this.post("MemIzinSuresiBul", request);
    }

    perSicilBilgiOzelList(request: PerSicilBilgiOzelListRequest) {
        return this.post("PerSicilBilgiOzelList", request);
    }

    perIzinTuruTanimiDetayGet(request: PerIzinTuruTanimiDetayGetRequest) {
        return this.post("PerIzinTuruTanimiDetayGet", request);
    }
}
export default new MemurIzinTalepAPI();

class PerSicilBilgiKontrolRequest {
    vatandaslikNo?: string;

    constructor(
        vatandaslikNo?: string
    ) {
        this.vatandaslikNo = vatandaslikNo;
    }
}
export { PerSicilBilgiKontrolRequest };

class MemIzinTalepDelRequest {
    sqId?: number;

    constructor(
        sqId?: number
    ) {
        this.sqId = sqId;
    }
}
export { MemIzinTalepDelRequest };

class MemIzinTalepGetRequest {
    sqId?: number;

    constructor(
        sqId?: number
    ) {
        this.sqId = sqId;
    }
}
export { MemIzinTalepGetRequest };

class MemIzinTalepListRequest {
    vMemurIsci?: string;
    vQtSicilId?: number;

    constructor(
        vMemurIsci?: string,
        vQtSicilId?: number
    ) {
        this.vMemurIsci = vMemurIsci;
        this.vQtSicilId = vQtSicilId;
    }
}
export { MemIzinTalepListRequest };

class MemIzinTalepSaveRequest {
    sqId?: number;
    rfMemOzlukBilgi?: number;
    rfPerIzinTuruDetayTnm?: number;
    dtIzinTalepTarihi?: Date;
    dtIzinAyrilisTarihi?: Date;
    dtIzinBitisTarihi?: Date;
    qtKullanilanIzinSuresi?: number;
    qtYolIzni?: number;
    rfOrtIletisimMaster?: number;
    chIzinAdresi?: string;
    dtIseBaslamaTarihi?: Date;
    chAciklama?: string;
    ctDurum?: number;
    dtDurumTarih?: Date;
    chDurumAciklama?: string;
    username?: string;
    rfMemIzinHakedisBilgi?: number;
    rfPerSicilBilgiVekil?: number;
    rfPerSicilBilgiOnayaSun?: number;
    rfPerSicGorevOnayaSun?: number;
    rfPerSicilBilgiUygunG?: number;
    rfPerSicGorevUygunG?: number;
    rfPerSicilBilgiOnay?: number;
    rfPerSicGorevOnay?: number;

    constructor(
        sqId?: number,
        rfMemOzlukBilgi?: number,
        rfPerIzinTuruDetayTnm?: number,
        dtIzinTalepTarihi?: Date,
        dtIzinAyrilisTarihi?: Date,
        dtIzinBitisTarihi?: Date,
        qtKullanilanIzinSuresi?: number,
        qtYolIzni?: number,
        rfOrtIletisimMaster?: number,
        chIzinAdresi?: string,
        dtIseBaslamaTarihi?: Date,
        chAciklama?: string,
        ctDurum?: number,
        dtDurumTarih?: Date,
        chDurumAciklama?: string,
        username?: string,
        rfMemIzinHakedisBilgi?: number,
        rfPerSicilBilgiVekil?: number,
        rfPerSicilBilgiOnayaSun?: number,
        rfPerSicGorevOnayaSun?: number,
        rfPerSicilBilgiUygunG?: number,
        rfPerSicGorevUygunG?: number,
        rfPerSicilBilgiOnay?: number,
        rfPerSicGorevOnay?: number
    ) {
        this.sqId = sqId;
        this.rfMemOzlukBilgi = rfMemOzlukBilgi;
        this.rfPerIzinTuruDetayTnm = rfPerIzinTuruDetayTnm;
        this.dtIzinTalepTarihi = dtIzinTalepTarihi;
        this.dtIzinAyrilisTarihi = dtIzinAyrilisTarihi;
        this.dtIzinBitisTarihi = dtIzinBitisTarihi;
        this.qtKullanilanIzinSuresi = qtKullanilanIzinSuresi;
        this.qtYolIzni = qtYolIzni;
        this.rfOrtIletisimMaster = rfOrtIletisimMaster;
        this.chIzinAdresi = chIzinAdresi;
        this.dtIseBaslamaTarihi = dtIseBaslamaTarihi;
        this.chAciklama = chAciklama;
        this.ctDurum = ctDurum;
        this.dtDurumTarih = dtDurumTarih;
        this.chDurumAciklama = chDurumAciklama;
        this.username = username;
        this.rfMemIzinHakedisBilgi = rfMemIzinHakedisBilgi;
        this.rfPerSicilBilgiVekil = rfPerSicilBilgiVekil;
        this.rfPerSicilBilgiOnayaSun = rfPerSicilBilgiOnayaSun;
        this.rfPerSicGorevOnayaSun = rfPerSicGorevOnayaSun;
        this.rfPerSicilBilgiUygunG = rfPerSicilBilgiUygunG;
        this.rfPerSicGorevUygunG = rfPerSicGorevUygunG;
        this.rfPerSicilBilgiOnay = rfPerSicilBilgiOnay;
        this.rfPerSicGorevOnay = rfPerSicGorevOnay;
    }
}
export { MemIzinTalepSaveRequest };

class MemIzinTalepDetayListRequest {
    rfMemIzinTalep?: number;

    constructor(
        rfMemIzinTalep?: number
    ) {
        this.rfMemIzinTalep = rfMemIzinTalep;
    }
}
export { MemIzinTalepDetayListRequest };

class MemIzinTalepDurumUpdRequest {
    sqId?: number;
    username?: string;

    constructor(
        sqId?: number,
        username?: string
    ) {
        this.sqId = sqId;
        this.username = username;
    }
}
export { MemIzinTalepDurumUpdRequest };

class MemIzinDurumListRequest {
    rfMemOzlukBilgi?: number;
    perIzinTuruTanimiDetay?: number;
    dtIslemTarihi?: Date;

    constructor(
        rfMemOzlukBilgi?: number,
        perIzinTuruTanimiDetay?: number,
        dtIslemTarihi?: Date
    ) {
        this.rfMemOzlukBilgi = rfMemOzlukBilgi;
        this.perIzinTuruTanimiDetay = perIzinTuruTanimiDetay;
        this.dtIslemTarihi = dtIslemTarihi;
    }
}
export { MemIzinDurumListRequest };

class PerIzinTuruTanimiSaatListRequest {
    ctMemurIsci?: number;
    ctSaat?: number;

    constructor(
        ctMemurIsci?: number,
        ctSaat?: number
    ) {
        this.ctMemurIsci = ctMemurIsci;
        this.ctSaat = ctSaat;
    }
}
export { PerIzinTuruTanimiSaatListRequest };

class PerIzinTuruTnmDtySaatLstRequest {
    rfPerIzinTuruTanimi?: number;
    ctSaat?: number;

    constructor(
        rfPerIzinTuruTanimi?: number,
        ctSaat?: number
    ) {
        this.rfPerIzinTuruTanimi = rfPerIzinTuruTanimi;
        this.ctSaat = ctSaat;
    }
}
export { PerIzinTuruTnmDtySaatLstRequest };

class MemIzinSuresiBulRequest {
    rfMemOzlukBilgi?: number;
    rfPerIzinTuruTanimi?: number;
    rfPerIzinTuruTnmDetay?: number;
    dtIzinAyrilisTarihi?: Date;
    dtIzinBitisTarihi?: Date;
    qtIzinSuresi?: number;
    qtYolIzni?: number;

    constructor(
        rfMemOzlukBilgi?: number,
        rfPerIzinTuruTanimi?: number,
        rfPerIzinTuruTnmDetay?: number,
        dtIzinAyrilisTarihi?: Date,
        dtIzinBitisTarihi?: Date,
        qtIzinSuresi?: number,
        qtYolIzni?: number
    ) {
        this.rfMemOzlukBilgi = rfMemOzlukBilgi;
        this.rfPerIzinTuruTanimi = rfPerIzinTuruTanimi;
        this.rfPerIzinTuruTnmDetay = rfPerIzinTuruTnmDetay;
        this.dtIzinAyrilisTarihi = dtIzinAyrilisTarihi;
        this.dtIzinBitisTarihi = dtIzinBitisTarihi;
        this.qtIzinSuresi = qtIzinSuresi;
        this.qtYolIzni = qtYolIzni;
    }
}
export { MemIzinSuresiBulRequest };

class PerSicilBilgiOzelListRequest {
    dtBaslangicTarihi?: Date;
    perSicilBilgiSqid?: number;
    personelTuru?: number;
    chAdi?: string;
    chSoyadi?: string;
    qtTcKimlikNo?: number;
    qtKurumSicilNo?: number;
    calismaDurumu?: number;

    constructor(
        dtBaslangicTarihi?: Date,
        perSicilBilgiSqid?: number,
        personelTuru?: number,
        chAdi?: string,
        chSoyadi?: string,
        qtTcKimlikNo?: number,
        qtKurumSicilNo?: number,
        calismaDurumu?: number
    ) {
        this.dtBaslangicTarihi = dtBaslangicTarihi;
        this.perSicilBilgiSqid = perSicilBilgiSqid;
        this.personelTuru = personelTuru;
        this.chAdi = chAdi;
        this.chSoyadi = chSoyadi;
        this.qtTcKimlikNo = qtTcKimlikNo;
        this.qtKurumSicilNo = qtKurumSicilNo;
        this.calismaDurumu = calismaDurumu;
    }
}
export { PerSicilBilgiOzelListRequest };

class PerIzinTuruTanimiDetayGetRequest {
    sqId?: number;

    constructor(
        sqId?: number
    ) {
        this.sqId = sqId;
    }
}
export { PerIzinTuruTanimiDetayGetRequest };
